export function settingsRulesProvider(config) {
  const rules = config.fieldSettings?.rules;
  if (!rules || typeof rules !== 'object') return null;

  const out = {};
  if (Array.isArray(rules.effects))    out.effects    = rules.effects;
  if (Array.isArray(rules.validation)) out.validation = rules.validation;
  if (rules.optionFilter)              out.optionFilter = rules.optionFilter;
  if (typeof rules.isNonEditable === 'boolean') out.isNonEditable = rules.isNonEditable;
  return Object.keys(out).length ? out : null;
}